import React, { createContext, useContext, useReducer } from 'react';

const MovieContext = createContext();

const initialState = {
    profiles: [
        { id: 1, name: 'Juan Pérez', email: 'juan@email.com', color: 'from-red-500 to-pink-500' },
        { id: 2, name: 'María López', email: 'maria@email.com', color: 'from-blue-500 to-cyan-500' },
        { id: 3, name: 'Niños', email: 'kids@email.com', color: 'from-green-500 to-emerald-500' }
    ],
    currentProfileId: 1,
    favorites: { 1: [], 2: [], 3: [] },
    isMyListView: false,
    isVideoOpen: false,
    currentVideo: null,
    watchProgress: {} // NUEVO: Estado para el progreso de visualización
};

function movieReducer(state, action) {
    switch (action.type) {
        case 'SET_PROFILE':
            return { ...state, currentProfileId: action.payload };
        case 'TOGGLE_FAVORITE':
            const currentFavorites = state.favorites[state.currentProfileId] || [];
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    [state.currentProfileId]: currentFavorites.includes(action.payload)
                        ? currentFavorites.filter(id => id !== action.payload)
                        : [...currentFavorites, action.payload]
                }
            };
        case 'SET_MY_LIST_VIEW':
            return { ...state, isMyListView: action.payload };
        case 'OPEN_VIDEO':
            return {
                ...state,
                isVideoOpen: true,
                currentVideo: action.payload
            };
        case 'CLOSE_VIDEO':
            return { ...state, isVideoOpen: false, currentVideo: null };
        case 'UPDATE_WATCH_PROGRESS': // NUEVO: Actualizar progreso
            return {
                ...state,
                watchProgress: {
                    ...state.watchProgress,
                    [action.payload.movieId]: action.payload.progress
                }
            };
        default:
            return state;
    }
}

export function MovieProvider({ children }) {
    const [state, dispatch] = useReducer(movieReducer, initialState);

    const actions = {
        setProfile: (id) => dispatch({ type: 'SET_PROFILE', payload: id }),
        toggleFavorite: (id) => dispatch({ type: 'TOGGLE_FAVORITE', payload: id }),
        setMyListView: (value) => dispatch({ type: 'SET_MY_LIST_VIEW', payload: value }),
        openVideo: (movie) => dispatch({ type: 'OPEN_VIDEO', payload: movie }),
        closeVideo: () => dispatch({ type: 'CLOSE_VIDEO' }),
        updateWatchProgress: (movieId, progress) => dispatch({ // NUEVO
            type: 'UPDATE_WATCH_PROGRESS',
            payload: { movieId, progress }
        })
    };

    return (
        <MovieContext.Provider value={{ state, actions }}>
            {children}
        </MovieContext.Provider>
    );
}

export const useMovie = () => {
    const context = useContext(MovieContext);
    if (!context) {
        throw new Error('useMovie must be used within a MovieProvider');
    }
    return context;
};